module.exports = __webpack_public_path__ + "img/number.431ec124.svg";